let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ewwba")).then(() => parcelRequire('2gSlC'));